import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type AppSessionState = {
  location: any | null
  userPin: string[]
  userToken: string | null
  register?: any
  productViewMode: 'vertical' | 'horizontal'
  keyboardInputType: 'text' | 'number'
  showKeyboard: boolean
  order_sources: any[] | null
  delivery_methods: any[] | null
  future_order_types: any[] | null
  business_settings: any[] | null
}

const initialState: AppSessionState = {
  location: null,
  userPin: [],
  userToken: null,
  register: null,
  productViewMode: 'vertical',
  keyboardInputType: 'text',
  showKeyboard: false,
  order_sources: null,
  delivery_methods: null,
  future_order_types: null,
  business_settings: null,
}

const appSessionSlice = createSlice({
  name: 'app-session',
  initialState,
  reducers: {
    resetAppSession() {
      return initialState
    },

    setLocation(state, action: PayloadAction<any>) {
      state.location = action.payload
    },

    setUserPin(state, action: PayloadAction<any[]>) {
      state.userPin = action.payload
    },

    setUserToken(state, action: PayloadAction<string>) {
      state.userToken = action.payload
    },

    setRegister(state, action: PayloadAction<any>) {
      state.register = action.payload
    },

    setProductViewMode(
      state,
      action: PayloadAction<'vertical' | 'horizontal'>,
    ) {
      state.productViewMode = action.payload
    },

    setKeyboardInputType(state, action: PayloadAction<'text' | 'number'>) {
      state.keyboardInputType = action.payload
    },

    setShowKeyboard(state, action: PayloadAction<boolean>) {
      state.showKeyboard = action.payload
    },

    setLocationMetadata(state, action: PayloadAction<any>) {
      state.order_sources = action.payload.order_sources
      state.delivery_methods = action.payload.delivery_methods
      state.future_order_types = action.payload.future_order_types
      state.business_settings = action.payload.business_settings
    },
  },
})

export const {
  resetAppSession,
  setLocation,
  setUserPin,
  setUserToken,
  setRegister,
  setProductViewMode,
  setKeyboardInputType,
  setShowKeyboard,
  setLocationMetadata,
} = appSessionSlice.actions

export default appSessionSlice.reducer
